"use client";
/*
 * Documentation:
 * OW_Nav — https://app.subframe.com/4f62853ee923/library?component=OW_Nav_76f3382e-de6b-44dc-9ef8-77d63f195849
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Ow_NavRootProps extends React.HTMLAttributes<HTMLDivElement> {
  buttonSlot?: React.ReactNode;
  imageSlot?: React.ReactNode;
  className?: string;
}

const Ow_NavRoot = React.forwardRef<HTMLDivElement, Ow_NavRootProps>(
  function Ow_NavRoot(
    { buttonSlot, imageSlot, className, ...otherProps }: Ow_NavRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "flex w-full items-center gap-12 rounded-sm border border-solid border-neutral-border bg-default-background px-6 py-4 shadow-sm justify-between",
          className
        )}
        ref={ref}
        {...otherProps}
      >
        {imageSlot ? (
          <div className="flex h-6 items-center gap-12">{imageSlot}</div>
        ) : null}
        {buttonSlot ? (
          <div className="flex items-center gap-4">{buttonSlot}</div>
        ) : null}
      </div>
    );
  }
);

export const Ow_Nav = Ow_NavRoot;
